<hr style="margin-top: 0px; margin-bottom: 0px;">

<div *ngIf="actionQueuesLoaded && eventsLoaded && associatedUserGroupsLoaded && userGroupsLoaded; else loading"
      class="col-sm-12">
  <p-confirmDialog #cd>
    <ng-template pTemplate="footer">
      <button (click)="cd.reject()" class="btn btn-basic" type="button">No</button>
      <button (click)="cd.accept()" class="btn btn-success" type="button">Yes</button>
      <div class="far fa-comment pull-right" style="color:#5279bc; cursor: pointer; font-size: 20px; margin-left: 20px; margin-top: 8px" aria-hidden="true" (click)="addNotes2ChangeLog('EventTrigger')"></div>
    </ng-template>
  </p-confirmDialog>

  <p-table #triggerTable [columns]="actionQueueTableCols" [value]="actionQueuesDisplayed" sortField="name" [scrollable]="true" 
    scrollHeight="flex" [resizableColumns]="true" columnResizeMode="expand" >
    
    <ng-template let-columns pTemplate="header">
      <tr>
        <th *ngFor="let col of columns" 
            [ngStyle]="{'width': col.width}" 
            [pSortableColumn]="col.field" 
            style="background-color: var(--kig-section-header-bg); flex: none;" 
            [ngClass]="{'text-center': col.header == 'Logs' || col.header == 'Copy' || col.header == 'Edit' || col.header == 'Del' || col.header == 'Queued' || col.header == 'Active' || col.header == '#Events' || col.header == 'Stats'}">
          <!-- <div *ngIf="col.field == 'checkbox'" (click)="toggleCheckedEventsDisplayed()" style="padding-left: 2px; font-size: 20px;">▣</div> -->
          <div *ngIf="col.field != 'checkbox'">{{col.header}}</div>
        </th>
      </tr>
    </ng-template>

    <ng-template let-columns="columns" let-rowData pTemplate="body">
      <tr>
        <td *ngFor="let col of columns" [ngStyle]="{'width': col.width}" style="flex: none; border-width: 0px; padding: 5px 5px 5px 12px; vertical-align: middle;">

          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchCase="'name'">
              <div class="css-tooltip" [attr.tooltip-data]="rowData.id">
                {{rowData.name}}
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'currentValue'">
              <div class="text-center">
                <div *ngIf="rowData.userFeatureAccess['EvaluateEvent']">
                  <button (click)="evaluateEvent(rowData, true, false, true)" class="btn" type="button" [ngStyle]="{'background-color': getEventConditionStatusColor(rowData)}"
                        style="width: 100%; height: 30px; border-radius: 20px; border: 1px solid lightgray; padding-top: 4px; background-color: var(--kig-section-header-bg); color: black; font-size: 13px;">
                      {{ getConditionEvalValue(rowData) }}
                  </button>
                </div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'displayedOwner'">
              {{ getOwnerName(rowData) | slice:0:16 }}...
            </ng-container>

            <ng-container *ngSwitchCase="'modifiedDate'">
              {{ rowData.modifiedDate | date : 'medium' }}
            </ng-container>

            <ng-container *ngSwitchCase="'chartQueueStats'">
              <div class="text-center">
                <div (click)="showSensorDataPreview(rowData)" class="fas fa-chart-line" style="color: #1c4966; cursor: pointer; font-size: 16px;" ></div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'numEvents'">
              <div class="text-center">
                {{ rowData.eventIds.length }}
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'queuedEventActions'">
              <div class="text-center">
                <button (click)="openQueuedEventActions(rowData)" class="btn btn-sm" [ngStyle]="{'background-color': white}"
                          style="color: black; border-radius: 20px; border: 1px solid lightgray; padding-top: 4px; width: 100%" type="button">{{ rowData.queuedWaiting.length }}</button>
              </div>
            </ng-container>

            <!-- <ng-container *ngSwitchCase="'copy'">
              <div *ngIf="rowData.userFeatureAccess['CopyActionQueue']" class="text-center">
                <div (click)="copyActionQueue(rowData)" aria-hidden="true" class="pi pi-copy" style="color:#1c4966; cursor: pointer; font-size: 14px;">
                </div>
              </div>
            </ng-container> -->

            <ng-container *ngSwitchCase="'edit'">
              <div class="text-center">
                <div *ngIf="rowData.userFeatureAccess['EditActionQueue']" class="fas fa-pencil-alt"
                  (click)="editActionQueue(rowData)" aria-hidden="true"
                  style="color:#64a70b; cursor: pointer; font-size: 14px;">
                </div>
                <div *ngIf="rowData.userFeatureAccess['ViewActionQueue'] && !rowData.userFeatureAccess['EditActionQueue']"
                  (click)="editActionQueue(rowData)" aria-hidden="true" class="far fa-eye"
                  style="color:#1c4966; cursor: pointer; font-size: 14px;">
                </div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'delete'">
              <div *ngIf="rowData.userFeatureAccess['DeleteActionQueue']" class="text-center">
                <div (click)="onDeleteActionQueueConfirm(rowData)" aria-hidden="true" class="far fa-trash-alt" style="color:#c8102e; cursor: pointer; font-size: 14px;"></div>
                <span class="sr-only">Delete</span>
              </div>
            </ng-container>

          </ng-container>
        </td>
      </tr>
    </ng-template>

    <ng-template let-columns pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="columns.length">
          No search results
        </td>
      </tr>
    </ng-template>

    <ng-template let-rowData pTemplate="caption">
      <div style="text-align: left; display: flex; gap: 10px; align-items: center; margin-bottom: 0px; flex-wrap: wrap;">
        
          <div style="display: block; width: 170px;">
            <label style="font-size: large; vertical-align: middle; color:black; font-weight: 500;">ACTION QUEUES</label>
            <div style="display: flex; gap: 8px;" class="text-center">
              <div style="display: block; width: 70px;">
                <div style="font-size: 12px;">Displayed</div>
                <div style="font-size: 12px;">{{ actionQueuesDisplayed.length }}</div>
              </div>
              <!-- <div style="display: block;">
                <div style="font-size: 12px;">Selected</div>
                <div (click)="showSelectedEvents()" style="font-size: 12px; cursor: pointer;">{{ eventsCheckedCount }}</div>
              </div> -->
              <div style="display: block;">
                <div style="font-size: 12px;">Total</div>
                <div style="font-size: 12px;">{{ actionQueues.length }}</div>
              </div>
            </div>
          </div>

        <div style="text-align: left; display: flex; gap: 10px; align-items: center;">
          <form (ngSubmit)="searchActionQueuesTextChanged()">
              <i class="fa fa-search" style="margin:4px 4px 0 0; cursor: pointer;" (click)="searchActionQueuesTextChanged()"></i>
              <i class="fa-solid fa-magnifying-glass-minus" style="margin:4px 4px 0 0; cursor: pointer;" (click)="clearSearchFilter()"></i>
              <input [(ngModel)]="actionQueueSearchText" placeholder="Search" size="25" style="width:auto; height: 35px" type="text" name="actionQueueSearchText" autocomplete="off"/>
          </form>
        </div>
        <button style="height: 35px; padding-top: 4px;" (click)="createActionQueue()" class="btn btn-success" type="button">Create</button>
        <button style="height: 35px; padding-top: 4px;" (click)="refreshQueueStatus()" class="btn btn-primary" type="button">Refresh Status</button>
        <!-- <span style="border: 1px dotted lightgray; width: 300px; height: 35px; padding-top: 5px; padding-left: 5px; color: #c8102e">{{ updatedActionQueueToDisplay }}</span> -->

      </div> 
    </ng-template>
  </p-table>

</div>


<ng-template #loading>
  <div class="col-xs-4 col-lg-3">
    <i class="fa fa-spinner fa-spin fa-2x fa-fw" style="margin: 30px 10px 10px 30px;"></i>
    <span>Loading...</span>
  </div>
</ng-template>